import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FieldBuilder from "../../form-components/field-builder";
import EndPoints from "../../../services/end-points";

const GiveClientDiscount: React.FC = () => {
  const { t } = useTranslation();
  const [clients, setClients] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const fetchClients = async (reset = false, searchValue = search) => {
    try {
      setLoading(true);
      let res;
      if (searchValue != '') {
        res = await EndPoints.client.getAllClient({
          page: reset ? 1 : page,
          perPage: 20,
          light: true,
          keyword: searchValue,
        });
      }
      else {
        res = await EndPoints.client.getAllClient({
          page: reset ? 1 : page,
          perPage: 20,
          light: true,
        });
      }
      const newClients = res.data.data;

      setClients((prev) =>
        reset ? newClients : [...prev, ...newClients]
      );
      setHasMore(res.data.total > (reset ? newClients.length : clients.length + newClients.length));
      if (reset) setPage(2);
      else setPage((prev) => prev + 1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients(true);
  }, []);

  const handleScroll = async () => {
    if (loading || !hasMore) return;
    await fetchClients();
  };

  const handleSearch = async (value: string) => {
    setSearch(value);
    setPage(1);
    await fetchClients(true, value);
  };

  return (
    <Row gutter={[16, 8]}>
      <Col span={24}>
        <FieldBuilder
          name="clientId"
          label={t("client")}
          width="large"
          input={{
            type: "select-pagination",
            allowSearch: true,
            loading,
            options: clients.map((client) => ({
              label: `${client.firstName} ${client.lastName} ( ${client.cleanMobile} )`,
              value: client.id,
            })),
            handleScroll,
            handleSearch,
          }}
        />
      </Col>
    </Row>
  );
};

export default GiveClientDiscount;
